<template>
	<div class="profile">
		<div class="wrap container1">
			<div class="title">Info</div>
			<fields/>

			<template v-if="employee">
				<div class="title">Kontaktperson</div>
				<info v-bind="employee"/>
			</template>
		</div>
	</div>
</template>

<script>
import fields from "./fields/index.vue";
import info from "./info.vue";

export default {
	components: {fields, info},
	computed: {
		employee: (t) => t.$store.getters["user/employee"]
	}
};
</script>

<style lang="scss" scoped>
.profile {
	padding-top: 62px;

	.wrap {
		display: flex;

		@include res(tablet) {
			flex-direction: column;
		}

		.title {
			display: none;
			font-size: 18px;
			font-weight: 500;
			margin-bottom: 8px;

			@include res(tablet) {
				display: block;
				color: $white1;
			}

			@include res(mobile) {
				color: #3C9195;
			}
		}
	}
}
</style>
